/* ============================================================
   Champagne Pannier — comportements front
   1. Header transparent -> sombre au scroll (classe .cp-scrolled)
   2. Effervescence du hero (bulles dorées générées en JS)
   3. Révélation des sections au scroll (IntersectionObserver)
   Tout le STYLE vit dans assets/custom-champagne.css.
   Respecte prefers-reduced-motion (pas de bulles ni de masquage).
   ============================================================ */
(function () {
  var THRESHOLD = 40;
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- 1. Header au scroll -------------------------------- */
  function onScroll() {
    document.body.classList.toggle('cp-scrolled', window.pageYOffset > THRESHOLD);
  }

  /* --- 2. Bulles du hero ---------------------------------- */
  function buildBubbles(hero) {
    var layer = document.createElement('div');
    layer.className = 'cp-hero__bubbles';
    layer.setAttribute('aria-hidden', 'true');

    var COUNT = 16;
    for (var i = 0; i < COUNT; i++) {
      var bubble = document.createElement('span');
      bubble.className = 'cp-bubble';

      var size = 6 + Math.round(Math.random() * 16); // 6–22 px
      var left = Math.round(Math.random() * 100); // 0–100 %
      var duration = 7 + Math.random() * 9; // 7–16 s
      var delay = Math.random() * 8; // 0–8 s (décalage négatif = déjà en cours)
      var drift = (Math.random() * 40 - 20).toFixed(1); // -20–20 px

      bubble.style.width = size + 'px';
      bubble.style.height = size + 'px';
      bubble.style.left = left + '%';
      bubble.style.animationDuration = duration.toFixed(2) + 's';
      bubble.style.animationDelay = '-' + delay.toFixed(2) + 's';
      bubble.style.setProperty('--cp-drift', drift + 'px');

      layer.appendChild(bubble);
    }
    hero.insertBefore(layer, hero.firstChild);
  }

  /* --- 3. Révélation au scroll ---------------------------- */
  function initReveal() {
    var sections = document.querySelectorAll('main .shopify-section');
    // Si pas d'observer ou mouvement réduit : on laisse tout visible.
    if (!('IntersectionObserver' in window) || reduceMotion) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section) {
      section.classList.add('reveal');
      observer.observe(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('main[data-template="index"]')) {
      document.body.classList.add('cp-home');
      var hero = document.querySelector('.banner');
      if (hero) {
        hero.classList.add('cp-hero');
        if (!reduceMotion) buildBubbles(hero);
      }
    }
    initReveal();
    onScroll();
  });

  window.addEventListener('scroll', onScroll, { passive: true });
})();
